// src/api/axiosConfig.js
import axios from "axios";

// Create an axios instance
const apiClient = axios.create({
  // baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8085",
  baseURL:
    process.env.REACT_APP_API_BASE_URL || "https://api.vidyalokacollegeoba.com",
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 25000, // optional: 25s timeout
});

// Optional: request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // You can attach tokens or headers here if needed
    // Example:
    // const token = localStorage.getItem("authToken");
    // if (token) config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

export default apiClient;
